import React from "react"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Banner from "../components/banner"
import Section from "../components/section"
import ContactItem from "../components/contact-item"
import BMap from "../components/bmap"

import bannerPng from "../images/contact/banner.png"
import iconPhone from "../images/contact/icon-phone.png"
import iconFax from "../images/contact/icon-fax.png"
import iconAddress from "../images/contact/icon-address.png"
import iconEmail from "../images/contact/icon-email.png"

import "./contact.css"

const Page = () => (
  <Layout>
    <SEO title="联系我们" />
    <Banner image={bannerPng} />
    <Section>
      <div className="helloContainer">
        <h3>HELLO!&nbsp;&nbsp;&nbsp;&nbsp;您好</h3>
        <Row>
          <Col xs={12} sm={6}>
            <ContactItem
              iconSrc={iconPhone}
              text="010-63282880"
              style={{ float: "left" }}
            />
          </Col>
          <Col xs={12} sm={6}>
            <ContactItem
              iconSrc={iconFax}
              text="010-63282880"
              style={{ float: "left" }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6}>
            <ContactItem
              iconSrc={iconEmail}
              text="hr@highershine.com"
              style={{ float: "right", marginRight: 90 }}
            />
          </Col>
          <Col xs={12} sm={6}>
            <ContactItem
              iconSrc={iconAddress}
              text="北京市海淀区羊坊店路小马厂6号华天大厦518室"
              style={{ float: "right" }}
            />
          </Col>
        </Row>
      </div>
      <section style={{ height: 350 }}>
        <BMap />
      </section>
    </Section>
  </Layout>
)

export default Page
